import { MapPin, Building2, Phone, ArrowRight } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "./data";

const items = [
    { icon: MapPin, label: "Location", value: "Liluah, Howrah" },
    { icon: Building2, label: "Clinic", value: "The Tooth Care Dental Clinic" },
    { icon: Phone, label: "Contact", value: PHONE_DISPLAY, href: PHONE_TEL, testId: "info-strip-phone-link" },
];

export const InfoStrip = () => (
    <section aria-label="Quick information" className="bg-teal-600">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex flex-col lg:flex-row lg:items-center gap-8 lg:gap-10" data-testid="info-strip">
            <div className="grid sm:grid-cols-3 gap-6 flex-1">
                {items.map((item) => (
                    <div key={item.label} className="flex items-center gap-3.5">
                        <span className="h-11 w-11 rounded-xl bg-white/15 flex items-center justify-center shrink-0">
                            <item.icon className="h-5 w-5 text-white" strokeWidth={1.8} />
                        </span>
                        <span>
                            <span className="block text-[11px] font-bold uppercase tracking-[0.18em] text-teal-100">{item.label}</span>
                            {item.href ? (
                                <a href={item.href} data-testid={item.testId} className="block text-sm font-semibold text-white transition-colors duration-200 hover:text-teal-100 underline-offset-4 hover:underline">
                                    {item.value}
                                </a>
                            ) : (
                                <span className="block text-sm font-semibold text-white">{item.value}</span>
                            )}
                        </span>
                    </div>
                ))}
            </div>
            <a
                href="#appointment"
                data-testid="info-strip-book-btn"
                className="inline-flex items-center justify-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-semibold text-teal-700 transition-all duration-200 hover:bg-teal-50 hover:-translate-y-0.5 shrink-0"
            >
                Book Appointment
                <ArrowRight className="h-4 w-4" />
            </a>
        </div>
    </section>
);
